/* Inicio estilo Amazon — Moon Shop. Un solo archivo para todas las secciones. */
(function () {
  if (window.__amzInicio) { window.__amzInicio.todo(); return }

  var CLAVE = 'amz-vistos'
  function leerVistos () { try { return JSON.parse(localStorage.getItem(CLAVE) || '[]') || [] } catch (e) { return [] } }
  function dinero (c) { var n = (Number(c) || 0) / 100; return 'Q' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
  function precioAmz (c, chico) {
    var n = Math.round(Number(c) || 0), e = Math.floor(n / 100), ct = String(n % 100).padStart(2, '0')
    return '<span class="amzp' + (chico ? ' amzp--chico' : '') + '"><span class="amzp__q">Q</span><span class="amzp__e">' + e.toLocaleString('en-US') + '</span><span class="amzp__c">' + ct + '</span></span>'
  }
  function esc (s) { return String(s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m] }) }
  function img (src, ancho) {
    if (!src) return ''
    var u = String(src); if (u.indexOf('//') === 0) u = 'https:' + u
    u = u.replace(/([?&])width=\d+/, '$1width=' + ancho)
    return '<img src="' + esc(u) + '" alt="" loading="lazy">'
  }
  function tile (p, modo, etiqueta) {
    var pct = (p.c && p.c > p.p) ? Math.round((p.c - p.p) * 100 / p.c) : 0
    var h = '<a class="amzt amzt--' + modo + '" href="' + esc(p.u) + '" title="' + esc(p.t) + '"><span class="amzt__img">' + img(p.i, 400) + '</span>'
    if (modo === 'precio') h += '<span class="amzt__nombre">' + esc(p.t) + '</span>' + precioAmz(p.p)
    else if (modo === 'nombre') h += '<span class="amzt__nombre">' + esc(p.t) + '</span><span class="amzt__sub"><span class="amzp-plano">' + dinero(p.p) + '</span></span>'
    else if (modo === 'oferta') h += pct > 0 ? '<span class="amzt__of"><span class="amz-pct">-' + pct + '%</span>' + (etiqueta ? '<span class="amz-etq">' + esc(etiqueta) + '</span>' : '') + '</span>' : '<span class="amzt__of">' + precioAmz(p.p, true) + '</span>'
    return h + '</a>'
  }

  /* Productos vistos: los guarda la ficha (snippet amz-registrar-visto). Si hay pocos,
     se completa con los que vienen del servidor (la fuente de respaldo). */
  function vistos (raiz) {
    (raiz || document).querySelectorAll('[data-amz-vistos]').forEach(function (cont) {
      if (cont.dataset.amzListo) return; cont.dataset.amzListo = '1'
      var cuantos = Number(cont.dataset.cuantos || 4), modo = cont.dataset.modo || 'foto', etq = cont.dataset.etiqueta || ''
      /* Sin repetidos (revisor amz-unico): no se ofrece un producto que ya salió en otro grupo de más arriba. */
      var usados = window.__amzUsados || {}
      function hdl (u) { var m = String(u || '').match(/\/products\/([^?#\/]+)/); return m ? decodeURIComponent(m[1]).toLowerCase() : '' }
      var lista = leerVistos().filter(function (p) { if (!(p && p.u && p.i)) return false; var h = hdl(p.u); return !(usados[h] && usados[h] !== cont) })
      if (!lista.length) return
      var ya = {}, html = ''
      lista.slice(0, cuantos).forEach(function (p) { ya[p.u] = 1; html += tile(p, modo, etq) })
      var faltan = cuantos - Math.min(cuantos, lista.length)
      if (faltan > 0) {
        Array.prototype.slice.call(cont.children).forEach(function (el) {
          var a = el.matches('a') ? el : el.querySelector('a'); var href = a && a.getAttribute('href')
          if (faltan > 0 && href && !ya[href]) { html += el.outerHTML; ya[href] = 1; faltan-- }
        })
      }
      cont.innerHTML = html
      cont.querySelectorAll('a[href*="/products/"]').forEach(function (a) { var h = hdl(a.getAttribute('href')); if (h) usados[h] = cont })
      var t = cont.closest('[data-amz-titulo-vistos]')
      /* El título cambia a «Seguir comprando» solo si de verdad hay al menos 2 vistos en la fila:
         con uno solo y el resto relleno, se queda el título de siempre. */
      if (t && t.dataset.amzTituloVistos && Math.min(cuantos, lista.length) >= 2) { var h = t.querySelector('[data-amz-titulo]'); if (h) h.textContent = t.dataset.amzTituloVistos }
    })
  }

  /* INSPIRADO EN LO QUE VISTE (19-oct-2026): parecidos a los últimos vistos, según las
     recomendaciones de Shopify. Ni los que ya vio ni los que ya salieron en el inicio. */
  var NO_VAN = { 'envio-rapido': 1, 'regalo-sorpresa': 1, 'caja-sorpresa': 1, 'empaque-de-regalo': 1, 'gift-card-tarjeta-de-regalo': 1, test: 1, 'baterias-tripe-aaa': 1, '3x-baterias-aa-oferta': 1 }
  function handleDe (u) { var m = String(u || '').match(/\/products\/([^?#\/]+)/); return m ? decodeURIComponent(m[1]).toLowerCase() : '' }
  function inspirado (raiz) {
    var r0 = raiz || document, lista = Array.prototype.slice.call(r0.querySelectorAll('[data-amz-inspirado]'))
    if (r0.matches && r0.matches('[data-amz-inspirado]')) lista.unshift(r0)
    lista.forEach(function (sec) {
      if (sec.dataset.amzListo) return; sec.dataset.amzListo = '1'
      var carril = sec.querySelector('[data-amz-inspirado-carril]'); if (!carril || !window.fetch) return
      var vistos = leerVistos().filter(function (p) { return p && p.u })
      if (!vistos.length) return
      var raizUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'
      var base = vistos.slice(0, Number(sec.dataset.base || 3)), cuantos = Number(sec.dataset.cuantos || 10), minimo = Number(sec.dataset.minimo || 4)
      var vio = {}; vistos.forEach(function (p) { vio[handleDe(p.u)] = 1 })
      function idDe (p) {
        if (p.d) return Promise.resolve(p.d)
        return fetch(raizUrl + 'products/' + handleDe(p.u) + '.js').then(function (r) { return r.ok ? r.json() : null }).then(function (j) { return j && j.id })
      }
      Promise.all(base.map(function (p) {
        return idDe(p).then(function (id) {
          if (!id) return []
          return fetch(raizUrl + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=related').then(function (r) { return r.ok ? r.json() : { products: [] } }).then(function (j) { return j.products || [] })
        }).catch(function () { return [] })
      })).then(function (listas) {
        var usados = window.__amzUsados || {}, ya = {}, salen = [], i = 0, hay = true
        /* En una categoría (19-oct): tampoco lo que ya está en esa categoría, aunque todavía no se haya cargado. */
        var sinCat = sec.dataset.sinCat || ''
        /* Solo productos que el inicio puede ofrecer (lista amz-pool: con existencias, sin envío,
           regalo ni productos para adultos fuera de las categorías). Sin lista, no se filtra. */
        var permitidos = null
        try { var pl = document.getElementById('amz-pool'); if (pl) { permitidos = {}; JSON.parse(pl.textContent).forEach(function (x) { permitidos[x.h] = ',' + (x.k || '') + ',' }) } } catch (e) { permitidos = null }
        /* Se intercalan las listas: uno parecido al primer visto, uno al segundo… */
        while (salen.length < cuantos && hay) {
          hay = false
          listas.forEach(function (l) {
            var p = l[i]; if (!p) return; hay = true
            var h = (p.handle || handleDe(p.url)).toLowerCase()
            if (salen.length >= cuantos || ya[h] || vio[h] || NO_VAN[h] || usados[h] || p.available === false || (permitidos && !permitidos[h]) || (sinCat && permitidos && permitidos[h] && permitidos[h].indexOf(',' + sinCat + ',') >= 0)) return
            ya[h] = 1; salen.push({ h: h, u: String(p.url || '').split('?')[0], t: p.title, i: p.featured_image, p: p.price, c: p.compare_at_price || 0 })
          })
          i++
        }
        if (salen.length < minimo) return
        carril.innerHTML = salen.map(function (p) { return tile(p, 'nombre').replace('<a ', '<a data-amz-pid="' + esc(p.h) + '" ') }).join('')
        salen.forEach(function (p) { usados[p.h] = carril })
        sec.style.display = ''
      })
    })
  }

  /* Portada: la barra de arriba toma el color de la tarjeta que se está viendo,
     y se queda fija arriba al bajar. */
  function portada (raiz) {
    (raiz || document).querySelectorAll('[data-amz-portada]').forEach(function (p) {
      if (p.dataset.amzListo) return; p.dataset.amzListo = '1'
      var carril = p.querySelector('[data-amz-tarjetas]'), barra = p.querySelector('[data-amz-barra]')
      var tarjetas = carril ? carril.querySelectorAll('[data-color]') : []
      function color () {
        if (!tarjetas.length) return
        var izq = carril.getBoundingClientRect().left, mejor = tarjetas[0], dist = 1e9
        tarjetas.forEach(function (t) { var d = Math.abs(t.getBoundingClientRect().left - izq - 14); if (d < dist) { dist = d; mejor = t } })
        p.style.setProperty('--amz-c', mejor.dataset.color)
      }
      if (carril) { carril.addEventListener('scroll', function () { window.requestAnimationFrame(color) }, { passive: true }); color() }
      if (barra && barra.hasAttribute('data-amz-fija')) {
        /* Opcional (casilla «Que la barra siga al bajar»). El buscador se queda fijo arriba al bajar, como en Amazon. El hueco que deja
           lo ocupa un relleno del mismo alto para que la página no salte. */
        /* Ojo: el tema esconde los div vacíos (div:empty), por eso el display va forzado. */
        var hueco = document.createElement('div'); hueco.className = 'amzh__hueco'; hueco.style.setProperty('display', 'block', 'important'); hueco.style.height = '0px'; barra.parentNode.insertBefore(hueco, barra)
        var fija = false
        function revisar () {
          var tope = hueco.getBoundingClientRect().top
          var debe = tope < 0
          if (debe === fija) return
          fija = debe
          hueco.style.height = debe ? barra.offsetHeight + 'px' : '0px'
          barra.classList.toggle('is-fija', debe)
        }
        window.addEventListener('scroll', function () { window.requestAnimationFrame(revisar) }, { passive: true })
        revisar()
      }
    })
  }

  /* Ideas: contador «1 / 5» y puntitos */
  function ideas (raiz) {
    (raiz || document).querySelectorAll('[data-amz-ideas]').forEach(function (s) {
      if (s.dataset.amzListo) return; s.dataset.amzListo = '1'
      var carril = s.querySelector('.amzi__carril'), ideas = s.querySelectorAll('.amzi__idea'), puntos = s.querySelectorAll('.amzi__punto')
      function actual () {
        var izq = carril.getBoundingClientRect().left, n = 0, dist = 1e9
        ideas.forEach(function (el, i) { var d = Math.abs(el.getBoundingClientRect().left - izq); if (d < dist) { dist = d; n = i } })
        puntos.forEach(function (pt, i) { pt.classList.toggle('is-on', i === n) })
      }
      carril.addEventListener('scroll', function () { window.requestAnimationFrame(actual) }, { passive: true })
      puntos.forEach(function (pt, i) { pt.addEventListener('click', function () { carril.scrollTo({ left: ideas[i].offsetLeft - carril.offsetLeft - parseFloat(getComputedStyle(carril).paddingLeft || 0), behavior: 'smooth' }) }) })
      actual()
    })
  }

  /* Menú ☰: abre de la izquierda, se cierra con la X, el fondo oscuro o Escape */
  function menu (raiz) {
    (raiz || document).querySelectorAll('[data-amz-abrir-menu]').forEach(function (btn) {
      if (btn.dataset.amzListo) return; btn.dataset.amzListo = '1'
      var m = document.getElementById(btn.getAttribute('aria-controls')); if (!m) return
      if (m.parentNode !== document.body) {
        /* En el editor, al recargar la sección queda el menú viejo en el body: se quita */
        Array.prototype.forEach.call(document.body.children, function (el) { if (el !== m && el.id === m.id) el.remove() })
        document.body.appendChild(m)
      }
      function abrir () {
        m.hidden = false; document.documentElement.classList.add('amzm-bloqueo'); btn.setAttribute('aria-expanded', 'true')
        window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { m.classList.add('is-abierto') }) })
        var f = m.querySelector('.amzm__inicio'); if (f) f.focus({ preventScroll: true })
      }
      function cerrar () {
        m.classList.remove('is-abierto'); btn.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('amzm-bloqueo')
        setTimeout(function () { if (!m.classList.contains('is-abierto')) m.hidden = true }, 300)
      }
      btn.addEventListener('click', abrir)
      m.querySelectorAll('[data-amz-cerrar-menu]').forEach(function (c) { c.addEventListener('click', cerrar) })
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) cerrar() })
      m.querySelectorAll('[data-amz-ver-todo-boton]').forEach(function (v) {
        v.addEventListener('click', function () {
          var g = v.closest('[data-amz-ver-todo]'), on = g.classList.toggle('is-todo'), t = v.querySelector('span')
          v.setAttribute('aria-expanded', on ? 'true' : 'false'); t.textContent = on ? t.dataset.textoCerrar : t.dataset.textoAbrir
        })
      })
    })
  }

  /* Secciones que se dibujan al ir bajando (snippet amz-diferir) */
  function diferidos () {
    var pendientes = document.querySelectorAll('[data-amz-diferido]:not([data-amz-visto])')
    function poner (el) {
      if (!el.isConnected) return
      var t = el.querySelector('template'); if (!t) return
      var frag = t.content.cloneNode(true), padre = el.parentNode
      /* Sin repetidos: se cambian ANTES de dibujar, así no se ve el cambio (snippet amz-unico). */
      if (window.amzUnico) window.amzUnico(frag)
      var hijos = Array.prototype.slice.call(frag.childNodes)
      padre.replaceChild(frag, el)
      hijos.forEach(function (n) { if (n.nodeType === 1) { todo(n); if (window.__amzCarrito) window.__amzCarrito() } })
    }
    if (!('IntersectionObserver' in window)) { pendientes.forEach(poner); return }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); poner(e.target) } }) }, { rootMargin: '900px 0px' })
    pendientes.forEach(function (el) { el.setAttribute('data-amz-visto', ''); io.observe(el) })
  }


  /* Buscador con sugerencias mientras se escribe (como Amazon). Usa las sugerencias de Shopify
     (/search/suggest.json). La lista cuelga del body porque el formulario corta lo que se le sale. */
  var caja = null, formActivo = null, pedido = null, espera = null, marcado = -1
  function lista () {
    if (caja) return caja
    caja = document.createElement('div'); caja.className = 'amzs'; caja.hidden = true; caja.setAttribute('role', 'listbox')
    caja.addEventListener('mousedown', function (e) { e.preventDefault() })
    document.body.appendChild(caja)
    return caja
  }
  function ubicar () {
    if (!caja || !formActivo) return
    var r = formActivo.getBoundingClientRect()
    caja.style.top = (r.bottom + 4) + 'px'; caja.style.left = r.left + 'px'; caja.style.width = r.width + 'px'
    caja.style.maxHeight = Math.max(160, window.innerHeight - r.bottom - 16) + 'px'
  }
  function cerrar () { if (caja) caja.hidden = true; marcado = -1 }
  function resaltar (texto, q) {
    var i = texto.toLowerCase().indexOf(q.toLowerCase())
    if (i < 0) return '<b>' + esc(texto) + '</b>'
    return esc(texto.slice(0, i + q.length)) + '<b>' + esc(texto.slice(i + q.length)) + '</b>'
  }
  var LUPA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></svg>'
  function urlBusqueda (q) { return (formActivo.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q) + '&type=product' }
  function distancia (a, b) {
    var m = a.length, n = b.length, d = [], i, j
    for (i = 0; i <= m; i++) d[i] = [i]
    for (j = 1; j <= n; j++) d[0][j] = j
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1))
    return d[m][n]
  }
  function parecida (w, x) {
    if (!x || x.length < 3) return false
    if (x.indexOf(w) === 0 || (w.length >= 4 && x.indexOf(w.slice(0, 4)) === 0 && w.indexOf(x.slice(0, Math.min(x.length, w.length))) === 0)) return true
    var corte = x.slice(0, w.length + 1)
    var tope = w.length >= 7 ? 2 : (w.length >= 4 ? 1 : 0)
    return tope > 0 && (distancia(w, x) <= tope || distancia(w, corte) <= tope || distancia(w, x.slice(0, w.length)) <= tope)
  }
  function pintar (q, r) {
    var c = lista(), h = '', prods = (r.products || []), colecs = (r.collections || []), frases = (r.queries || [])
    // Primero lo que de verdad dice la palabra en el título; si nada la dice (una palabra mal escrita), lo que corrigió Shopify
    var norm = function (x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') }
    // Solo lo que se parece de verdad: empieza igual, o difiere en 1-2 letras («pulcera» → pulsera).
    // Con letras sin sentido Shopify inventa resultados (salían productos para adultos): esos no se muestran.
    var buscadas = norm(q).split(/[^a-z0-9ñ]+/).filter(function (w) { return w.length >= 3 })
    var dicen = prods.filter(function (p) {
      var palabras = norm([p.title, p.type, [].concat(p.tags || []).join(' ')].join(' ')).split(/[^a-z0-9ñ]+/)
      return buscadas.some(function (w) { return palabras.some(function (x) { return parecida(w, x) }) })
    })
    prods = dicen.slice(0, 6)
    colecs = colecs.filter(function (k) { var palabras = norm(k.title).split(/[^a-z0-9ñ]+/); return buscadas.some(function (w) { return palabras.some(function (x) { return parecida(w, x) }) }) })
    frases.slice(0, 4).forEach(function (f) {
      h += '<a class="amzs__fila amzs__frase" role="option" href="' + urlBusqueda(f.text) + '">' + LUPA + '<span>' + resaltar(f.text, q) + '</span></a>'
    })
    if (prods.length) h += '<div class="amzs__tit">Productos</div>'
    prods.forEach(function (p) {
      var precio = Math.round(Number(p.price) * 100), antes = Math.round(Number(p.compare_at_price_max || 0) * 100)
      var foto = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '')
      h += '<a class="amzs__fila amzs__prod' + (p.available === false ? ' is-agotado' : '') + '" role="option" href="' + esc(p.url) + '">' +
        '<span class="amzs__foto">' + (foto ? '<img src="' + esc(foto) + (foto.indexOf('?') < 0 ? '?' : '&') + 'width=120" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="amzs__txt"><span class="amzs__nombre">' + esc(p.title) + '</span>' +
        '<span class="amzs__precio">' + dinero(precio) + (antes > precio ? ' <s>' + dinero(antes) + '</s>' : '') + (p.available === false ? ' · Agotado' : '') + '</span></span></a>'
    })
    if (colecs.length) h += '<div class="amzs__tit">Categorías</div>'
    colecs.slice(0, 3).forEach(function (k) {
      h += '<a class="amzs__fila amzs__frase" role="option" href="' + esc(k.url) + '">' + LUPA + '<span>' + esc(k.title) + '</span></a>'
    })
    var nada = !frases.length && !prods.length && !colecs.length
    if (nada) h += '<div class="amzs__vacio">No encontramos «' + esc(q) + '». Prueba con otra palabra.</div><div data-amzs-populares></div>'
    else h += '<a class="amzs__fila amzs__todos" role="option" href="' + urlBusqueda(q) + '">Ver todos los resultados de «' + esc(q) + '»</a>'
    c.innerHTML = h; marcado = -1; ubicar(); c.hidden = false
    if (nada) populares(c.querySelector('[data-amzs-populares]'))
  }
  // Sin resultados: en vez de una caja vacía, lo más vendido (Moon tiene pocos productos: mejor llevar a algo que se vende)
  var cachePopulares = null
  function populares (destino) {
    var pintarPop = function (lista) {
      if (!destino || !lista.length) return
      var h = '<div class="amzs__tit">Lo más vendido</div>'
      lista.forEach(function (p) {
        var v = (p.variants || [])[0] || {}, precio = Math.round(Number(v.price) * 100), antes = Math.round(Number(v.compare_at_price || 0) * 100)
        var foto = (p.images && p.images[0] && p.images[0].src) || ''
        h += '<a class="amzs__fila amzs__prod" role="option" href="/products/' + esc(p.handle) + '">' +
          '<span class="amzs__foto">' + (foto ? '<img src="' + esc(foto) + (foto.indexOf('?') < 0 ? '?' : '&') + 'width=120" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="amzs__txt"><span class="amzs__nombre">' + esc(p.title) + '</span><span class="amzs__precio">' + dinero(precio) + (antes > precio ? ' <s>' + dinero(antes) + '</s>' : '') + '</span></span></a>'
      })
      destino.innerHTML = h
    }
    if (cachePopulares) { pintarPop(cachePopulares); return }
    fetch('/collections/lo-mas-vendido/products.json?limit=8').then(function (r) { return r.json() }).then(function (j) {
      cachePopulares = (j.products || []).filter(function (p) { return (p.variants || []).some(function (v) { return v.available }) }).slice(0, 4)
      pintarPop(cachePopulares)
    }).catch(function () {})
  }
  function sugerir (form) {
    var inp = form.querySelector('input[name=q]'), q = inp.value.trim()
    formActivo = form
    if (q.length < 2) { cerrar(); return }
    if (pedido) pedido.abort()
    pedido = window.AbortController ? new AbortController() : null
    var u = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query,product,collection&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=hide'
    fetch(u, pedido ? { signal: pedido.signal } : undefined).then(function (r) { return r.json() }).then(function (j) {
      if (inp.value.trim() !== q || document.activeElement !== inp) return
      pintar(q, (j.resources && j.resources.results) || {})
    }).catch(function () {})
  }
  function mover (paso) {
    if (!caja || caja.hidden) return false
    var filas = caja.querySelectorAll('.amzs__fila'); if (!filas.length) return false
    if (filas[marcado]) filas[marcado].classList.remove('is-on')
    marcado = (marcado + paso + filas.length) % filas.length
    filas[marcado].classList.add('is-on'); filas[marcado].scrollIntoView({ block: 'nearest' })
    return true
  }
  function buscador () {
    document.querySelectorAll('form.amzn__buscar').forEach(function (form) {
      if (form.dataset.amzBuscar) return; form.dataset.amzBuscar = '1'
      var inp = form.querySelector('input[name=q]'); if (!inp) return
      inp.addEventListener('input', function () { clearTimeout(espera); espera = setTimeout(function () { sugerir(form) }, 160) })
      inp.addEventListener('focus', function () { if (inp.value.trim().length >= 2) sugerir(form) })
      inp.addEventListener('blur', function () { setTimeout(cerrar, 150) })
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { if (mover(1)) e.preventDefault() }
        else if (e.key === 'ArrowUp') { if (mover(-1)) e.preventDefault() }
        else if (e.key === 'Escape') cerrar()
        else if (e.key === 'Enter' && caja && !caja.hidden && marcado >= 0) {
          var f = caja.querySelectorAll('.amzs__fila')[marcado]; if (f) { e.preventDefault(); location.href = f.href }
        }
      })
      form.addEventListener('submit', function (e) { if (!inp.value.trim()) { e.preventDefault(); inp.focus() } })
    })
  }
  window.addEventListener('resize', ubicar)
  window.addEventListener('scroll', ubicar, { passive: true })


  /* Ficha de producto: pestañas Arriba / Detalles / Explorar / Opiniones (como Amazon).
     Aparecen cuando el botón de compra ya quedó arriba. Si no hay opiniones, la pestaña avisa al tocarla. */
  function pestanas () {
    var nav = document.querySelector('[data-amz-pestanas]'); if (!nav || nav.dataset.amzListo) return; nav.dataset.amzListo = '1'
    document.body.appendChild(nav)
    function buscar (fines, palabras) {
      for (var i = 0; i < fines.length; i++) { var e = document.querySelector('[id$="__' + fines[i] + '"]'); if (e && e.offsetHeight) return e }
      var secs = document.querySelectorAll('main .shopify-section')
      for (var j = 0; j < secs.length; j++) { var t = (secs[j].innerText || '').trim().slice(0, 60).toLowerCase(); if (secs[j].offsetHeight && palabras.some(function (w) { return t.indexOf(w) === 0 })) return secs[j] }
      return null
    }
    var destinos = {
      detalles: function () { return buscar(['detalles_producto'], ['detalles del producto', 'acerca de']) || document.querySelector('main .product__description') || buscar(['descripcion_desplegable_wmkin3'], ['descripción']) },
      explorar: function () { return buscar(['productos_similares', 'carrusel_productos_8cTHHd', 'related-products'], ['productos similares', 'también podría', 'tambien podria', 'también te puede', 'nuevos ingresos']) },
      opiniones: function () { var px = document.querySelector('.pxre'); if (px && px.offsetHeight) return px; return buscar(['titulo_resenas', 'resenas_loox'], ['reseñas', 'opiniones']) || document.getElementById('looxReviews') }
    }
    /* 29-oct: con el formulario de Pixel, Releasit y el formulario de Shopify están escondidos (miden 0); manda el botón nuevo. */
    var boton = function () { var c = [document.querySelector('[data-amzt-compra] [data-amzt-agregar]'), document.querySelector('#_rsi-buy-now-button'), document.querySelector('form[action*="/cart/add"] [type=submit]')]; for (var i = 0; i < c.length; i++) if (c[i] && c[i].offsetHeight) return c[i]; return null }
    var alto = function () { return nav.offsetHeight || 52 }
    var aviso = nav.querySelector('[data-amz-pest-aviso]'), tAviso
    function ir (y) { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }) }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ir]'); if (!b) return
      var q = b.dataset.ir
      if (q === 'arriba') { ir(0); return }
      if (q === 'opiniones' && nav.dataset.sinOpiniones) {
        aviso.hidden = false; clearTimeout(tAviso); tAviso = setTimeout(function () { aviso.hidden = true }, 2600); return
      }
      var d = destinos[q] && destinos[q](); if (d) ir(d.getBoundingClientRect().top + window.scrollY - alto() - 6)
    })
    var revisadas = false
    function revisar () {
      var bt = boton(), ver = bt ? bt.getBoundingClientRect().bottom < 0 : window.scrollY > 900
      nav.classList.toggle('is-ver', ver)
      if (!ver) return
      // Una pestaña sin a dónde llevar no se muestra (Opiniones sí: avisa si no hay)
      if (!revisadas) { revisadas = true; ['detalles', 'explorar'].forEach(function (k) { var b = nav.querySelector('[data-ir="' + k + '"]'); if (b && !destinos[k]()) b.hidden = true }) }
      // La marcada es la parte que ya llegó arriba y está más abajo en la página (el orden cambia según la plantilla)
      var activa = '', limite = alto() + 20, mejor = -1e9
      ;['detalles', 'explorar', 'opiniones'].forEach(function (k) { var d = destinos[k](); if (!d) return; var top = d.getBoundingClientRect().top; if (top <= limite && top > mejor) { mejor = top; activa = k } })
      nav.querySelectorAll('[data-ir]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.ir === activa) })
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(revisar) }, { passive: true })
    revisar()
  }


  /* Inicio sin fin: al acercarse al final se pide la siguiente fila (una colección a la vez) */
  function infinito () {
    var raiz = document.querySelector('[data-amz-infinito]'); if (!raiz || raiz.dataset.amzListo) return; raiz.dataset.amzListo = '1'
    var lista = (raiz.dataset.amzInfinito || '').split(',').filter(Boolean)
    if (raiz.dataset.azar === 'true') lista.sort(function () { return Math.random() - 0.5 })
    var filas = raiz.querySelector('[data-amz-infinito-filas]'), mas = raiz.querySelector('[data-amz-infinito-mas]'), i = 0, ocupado = false, yaEnFilas = {}
    function terminar () { mas.remove(); if (io) io.disconnect() }
    function siguiente () {
      if (ocupado) return
      if (i >= lista.length) { terminar(); return }
      ocupado = true
      var h = lista[i++]
      fetch('/collections/' + encodeURIComponent(h) + '?section_id=amz-fila-coleccion').then(function (r) { return r.ok ? r.text() : '' }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'), f = d.querySelector('[data-amz-fila]')
        if (f) {
          /* Sin repetidos entre filas (Pablo, 20-oct: la cosmetiquera salía en «Luces» y en «Belleza»,
             una encima de la otra). La fila trae hasta 24; se quitan los que ya salieron en una fila de
             arriba y se dejan 12. Con menos de 4 la fila no sale. */
          var quedan = 0
          Array.prototype.forEach.call(f.querySelectorAll('[data-amz-tarjeta]'), function (t) {
            var a = t.querySelector('a[href*="/products/"]'), m = a && a.getAttribute('href').match(/\/products\/([^?#\/]+)/)
            var h = m ? decodeURIComponent(m[1]).toLowerCase() : ''
            if ((h && yaEnFilas[h]) || quedan >= 12) { t.remove(); return }
            if (h) t.dataset.amzH = h
            quedan++
          })
          if (quedan >= 4) {
            Array.prototype.forEach.call(f.querySelectorAll('[data-amz-h]'), function (t) { yaEnFilas[t.dataset.amzH] = 1 })
            var nueva = document.importNode(f, true); filas.appendChild(nueva); flechas(nueva.parentNode)
          }
        }
      }).catch(function () {}).then(function () {
        ocupado = false
        // si la fila vino vacía o todavía estamos cerca del final, seguir
        if (mas.isConnected && mas.getBoundingClientRect().top < window.innerHeight + 1200) siguiente()
      })
    }
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { if (es[0].isIntersecting) siguiente() }, { rootMargin: '1200px 0px' }) : null
    if (io) io.observe(mas); else siguiente()
  }

  /* Franja que se desliza (amz-banner-producto con varios productos): los puntitos siguen al dedo y llevan al producto */
  function carruseles (raiz) {
    (raiz || document).querySelectorAll('[data-amzd-carrusel]').forEach(function (c) {
      if (c.dataset.amzListo) return; c.dataset.amzListo = '1'
      var carril = c.querySelector('[data-amzd-carril]'), puntos = c.querySelectorAll('[data-amzd-punto]')
      if (!carril || !puntos.length) return
      function actual () { return Math.round(carril.scrollLeft / Math.max(1, carril.clientWidth)) }
      function marcar () {
        var i = actual()
        puntos.forEach(function (p, k) { p.classList.toggle('is-on', k === i); if (k === i) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current') })
      }
      var espera = null
      carril.addEventListener('scroll', function () { if (espera) cancelAnimationFrame(espera); espera = requestAnimationFrame(marcar) }, { passive: true })
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { carril.scrollTo({ left: Number(p.dataset.amzdPunto) * carril.clientWidth, behavior: 'smooth' }) })
      })
    })
  }

  /* Tiras con flechas a los lados (como Amazon en la computadora). Las flechas solo salen si la tira
     no cabe y se esconden en la punta a la que ya se llegó. En el celular se desliza con el dedo. */
  function flechas (raiz) {
    (raiz || document).querySelectorAll('[data-amz-flechas]').forEach(function (m) {
      if (m.dataset.amzListo) return; m.dataset.amzListo = '1'
      var c = m.querySelector('[data-amz-flechas-carril]'); if (!c) return
      var izq = m.querySelector('[data-amz-flecha="-1"]'), der = m.querySelector('[data-amz-flecha="1"]')
      function ver () {
        var max = c.scrollWidth - c.clientWidth - 2
        if (izq) izq.hidden = c.scrollLeft <= 2
        if (der) der.hidden = c.scrollLeft >= max
      }
      m.querySelectorAll('[data-amz-flecha]').forEach(function (b) {
        b.addEventListener('click', function () { c.scrollBy({ left: Number(b.dataset.amzFlecha) * c.clientWidth * 0.85, behavior: 'smooth' }) })
      })
      c.addEventListener('scroll', function () { requestAnimationFrame(ver) }, { passive: true })
      window.addEventListener('resize', ver); ver(); setTimeout(ver, 400)
    })
  }

  /* Galería de la ficha en el celular (Pablo, 20 y 21-oct).
     1) Puntitos como Amazon: nunca más de 5. Si hay más fotos, el de la punta que tiene más fotos
        detrás sale chiquito; la ventana sigue a la foto que se ve. Los puntitos originales de la
        plantilla (#bm-dots .bm-dots__p) se quedan escondidos pero vivos: pixel-tienda lee el encendido.
     2) SIN DESTELLO (21-oct, «al actualizar sale un destello del diseño anterior»): la plantilla arma
        su fila en DOMContentLoaded y este archivo (defer) corre ANTES, así que antes se esperaba con
        un reloj de 250 ms y durante ese rato se pintaban los 11 puntitos viejos. Ahora se arma en el
        mismo DOMContentLoaded, justo después del de la plantilla (mismo turno, sin pintar en medio).
        Además el CSS ya viste los viejos igual que los nuevos, y los botones nacen con su tamaño final
        (antes el 5.º nacía grande y se encogía con animación delante del cliente).
     3) DESLIZAR NATURAL (21-oct, «es como robótico y se congela a la mitad»): el iPhone desliza y se
        acomoda solo con el scroll-snap del CSS. Antes un reloj de 180-320 ms después de soltar el dedo
        lanzaba un scrollTo animado que se peleaba con la inercia del iPhone: ese era el tirón y la
        foto parada a la mitad. Ya no se mueve nada mientras el iPhone se mueve. Solo si la galería
        lleva 700 ms quieta, sin dedo, y de verdad quedó entre dos fotos, se lleva a la más cercana.
        Al deslizar ya no se mide la página en cada cuadro: las posiciones se miden una vez y se
        vuelven a medir solo si cambia el tamaño. */
  function galeria () {
    var visor = document.querySelector('[id^="GalleryViewer"]'); if (!visor) return
    var ul = visor.querySelector('.product__media-list'); if (!ul || ul.dataset.amzGaleria) return
    ul.dataset.amzGaleria = '1'
    var cel = window.matchMedia('(max-width: 749px)')
    var pos = []
    function medir () {
      var lis = Array.prototype.filter.call(ul.children, function (li) { return li.offsetWidth > 0 })
      var max = Math.max(0, ul.scrollWidth - ul.clientWidth), cero = lis.length ? lis[0].offsetLeft : 0
      pos = lis.map(function (li) { return Math.max(0, Math.min(max, li.offsetLeft - cero)) })
    }
    function cercano (x) {
      var k = 0
      for (var i = 1; i < pos.length; i++) if (Math.abs(pos[i] - x) < Math.abs(pos[k] - x)) k = i
      return k
    }
    /* — puntitos — */
    var mio = null, botones = [], cuantas = 0, activo = -1
    function pintar (forzar) {
      if (!mio) return
      var a = cercano(ul.scrollLeft)
      if (a === activo && !forzar) return
      activo = a
      var V = botones.length, s = Math.max(0, Math.min(cuantas - V, a - 2))
      for (var j = 0; j < V; j++) {
        var b = botones[j], i = s + j
        b.dataset.i = i
        b.className = 'amzgp__d' + (i === a ? ' is-on' : '') + (((j === 0 && s > 0) || (j === V - 1 && s + V < cuantas)) ? ' is-chico' : '')
        b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' de ' + cuantas)
        if (i === a) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current')
      }
    }
    function armar () {
      if (mio) return true
      var fila = document.getElementById('bm-dots'); if (!fila) return false
      medir(); cuantas = pos.length
      var nuevo = document.createElement('div'); nuevo.className = 'amzgp'
      botones = []
      for (var j = 0; j < (cuantas < 2 ? 0 : Math.min(5, cuantas)); j++) {
        var b = document.createElement('button'); b.type = 'button'
        b.addEventListener('click', function () { var x = pos[Number(this.dataset.i)]; if (x !== undefined) ul.scrollTo({ left: x, behavior: 'smooth' }) })
        nuevo.appendChild(b); botones.push(b)
      }
      mio = nuevo; activo = -1; pintar(true)           // los botones nacen con su tamaño final
      fila.insertBefore(mio, fila.firstChild); fila.classList.add('amzg-listo')
      /* La animación de tamaño se enciende recién después del primer cuadro pintado. */
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (mio) mio.classList.add('amzgp--vivo') }) })
      return true
    }
    function rehacer () {
      var antes = pos.length; medir()
      if (mio && pos.length !== cuantas) { mio.remove(); mio = null; armar() } else pintar(antes !== pos.length)
    }
    var cuadro = 0
    ul.addEventListener('scroll', function () {
      if (!cuadro) cuadro = requestAnimationFrame(function () { cuadro = 0; pintar() })
      if (!dedo) vigilar()
    }, { passive: true })
    if (window.ResizeObserver) new ResizeObserver(function () { rehacer() }).observe(ul)
    else window.addEventListener('resize', rehacer)
    if (!armar()) {
      /* La plantilla arma #bm-dots en DOMContentLoaded; este escuchador queda detrás del suyo. */
      /* Un script defer corre con readyState «interactive», antes de DOMContentLoaded: se escucha igual. */
      if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', armar)
      var v = 0, t = setInterval(function () { if (armar() || ++v > 40) clearInterval(t) }, 250)
    }
    /* — red de seguridad: solo si quedó parada entre dos fotos — */
    var dedo = false, quieto = 0
    function vigilar () { clearTimeout(quieto); quieto = setTimeout(revisar, 700) }
    function revisar () {
      if (dedo || !cel.matches || !pos.length) return
      var x1 = ul.scrollLeft
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        if (dedo || Math.abs(ul.scrollLeft - x1) > 0.5) return      // todavía se mueve: no se toca
        var k = cercano(x1); if (Math.abs(pos[k] - x1) > 2) ul.scrollTo({ left: pos[k], behavior: 'smooth' })
      }) })
    }
    ul.addEventListener('touchstart', function () { dedo = true; clearTimeout(quieto) }, { passive: true })
    function solto () { dedo = false; vigilar() }
    ul.addEventListener('touchend', solto, { passive: true }); ul.addEventListener('touchcancel', solto, { passive: true })
  }

  function todo (raiz) { try { galeria() } catch (e) {} vistos(raiz); inspirado(raiz); portada(raiz); ideas(raiz); menu(raiz); carruseles(raiz); flechas(raiz); buscador(); pestanas(); infinito(); if (!raiz) diferidos() }
  window.__amzInicio = { todo: todo }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { todo() }); else todo()
  document.addEventListener('shopify:section:load', function (e) { todo(e.target) })
})()
